import {
  api,
  LifeSkillCertificationBasicDataOfInteger,
  LifeSkillsCertification,
  LifeSkillsCertificationDetails,
  LifeSkillsCertificationSet,
  LifeSkillsRecertificationDate,
  PagedResultOfLifeSkillsCertificationInformation,
} from 'api';
import { rtkQueryApi } from 'store/rtkQueryApi';

export const lifeSkillsCertificationApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    lifeSkillsCertificationList: builder.query<
      PagedResultOfLifeSkillsCertificationInformation,
      { examinerId: number; page: number; count: number }
    >({
      query: (params) => api.lifeSkillsCertification.getLifeSkillsCertifications(params),
      providesTags: ['LifeSkillsCertificationList'],
    }),

    lifeSkillsCertSets: builder.query<LifeSkillsCertificationSet[], void>({
      query: () => api.lifeSkillsCertification.getLifeSkillsCertificationSets(),
      providesTags: ['LifeSkillsCertification'],
    }),

    lifeSkillsCertDetails: builder.query<LifeSkillsCertificationDetails, number>({
      query: (certificationId) => api.lifeSkillsCertification.getDetails({ certificationId }),
      providesTags: ['LifeSkillsCertification'],
    }),

    lifeSkillsRecertDates: builder.query<LifeSkillsRecertificationDate[], { examinerId: number }>({
      query: ({ examinerId }) =>
        api.lifeSkillsCertification.getNextLifeSkillsRecertificationDates({ examinerId }),
      providesTags: ['LifeSkillsCertificationList'],
    }),

    lifeSkillsLastPassedCertDates: builder.query<
      LifeSkillCertificationBasicDataOfInteger[],
      { examinerId: number }
    >({
      query: ({ examinerId }) =>
        api.lifeSkillsCertification.getLastPassedCertificationBasicData({ examinerId }),
      providesTags: ['LifeSkillsCertificationList'],
    }),

    saveLifeSkillsCert: builder.mutation<
      LifeSkillsCertification,
      Omit<LifeSkillsCertification, 'id' | 'isDeleted' | 'lifeSkillsMonitorings'>
    >({
      query: (data) =>
        api.lifeSkillsCertification.saveLifeSkillsCertification(data as LifeSkillsCertification),
      invalidatesTags: ['LifeSkillsCertification', 'LifeSkillsCertificationList', 'ExaminerStatus'],
    }),

    deleteLifeSkillsCert: builder.mutation<void, number>({
      query: (id) => api.lifeSkillsCertification.deleteLifeSkillsCertification({ id }),
      invalidatesTags: ['LifeSkillsCertificationList', 'ExaminerStatus'],
    }),
  }),
});

export const {
  useLifeSkillsCertificationListQuery,
  useLifeSkillsCertSetsQuery,
  useLifeSkillsCertDetailsQuery,
  useLifeSkillsRecertDatesQuery,
  useLifeSkillsLastPassedCertDatesQuery,
  useSaveLifeSkillsCertMutation,
  useDeleteLifeSkillsCertMutation,
} = lifeSkillsCertificationApi;
